import styles from './selector.module.css';

export default function HolidaysSelector({
  calendarItem,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  position,
  total,
}) {
  return (
    <div className={styles.selector}>
      <button
        type="button"
        className={styles.navButton}
        onClick={onPrevious}
        disabled={!hasPrevious}
        aria-label="Previous month"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15 18 9 12 15 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div className={styles.current}>
        <span className={styles.month}>{calendarItem?.month}</span>
        <span className={styles.year}>{calendarItem?.year}</span>
        {total > 1 && (
          <span className={styles.counter}>
            {position} / {total}
          </span>
        )}
      </div>
      <button
        type="button"
        className={styles.navButton}
        onClick={onNext}
        disabled={!hasNext}
        aria-label="Next month"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="9 18 15 12 9 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
}
